// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1BDFp","topBottomGutter":"Layout_topBottomGutter__1Vw27"};